import React, { useState, useEffect } from "react";

export default function ScrollHooks() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    console.log("Fase de Actualizacion Mov de Scroll");

    const detectarScroll = () => setScrollY(window.pageYOffset);

    window.addEventListener("scroll", detectarScroll);
    // return = "Fase de Desmontaje"
    return () => {
      window.removeEventListener("scroll", detectarScroll);
    };
  }, [scrollY]);

  useEffect(() => {
    console.log("Fase de Montaje");
  }, []);

  useEffect(() => {
    console.log("Fase de Actualizacion");
  });

  useEffect(() => {
    return () => {
      console.log("Fase de Desmontaje");
    };
  });

  return (
    <>
      <h2>Hookl - useEffect y el ciclo de vida</h2>
      <p>Scroll y del Navegador {parseInt(scrollY)}px </p>
    </>
  );
}
